import React from "react";

import OnePanel from "./OnePanel";
import Text from "./Text";

const MarketingAnalysis = () => {
  return (
    <OnePanel title="Marketing Analysis">
      <Text>
        This section we are going to review Head of Product and Marketing
        decisions and how they impact your Income Statement.
      </Text>
    </OnePanel>
  );
};

export default MarketingAnalysis;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingAnalysis.js